import { Fragment } from "react";
import BihamtaTable from "../../../Components/BihamtaTable";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Download, Upload } from "react-bootstrap-icons";
import { getStaffAttachments } from "../../store/api/StaffApi";
import { attachFile, downloadFile, deleteAttachment } from "../../../store/api/CommonFunctions";
import { setDialog } from "../../../store/api/CommonFunctions";
const StaffAttachments = (props) => {
    const { staffID } = props;
    const dispatch = useDispatch();
    const attachList = useSelector(state => state.StaffData.attachmentList);
    let dataList = {};
    if (attachList === "PENDING") {
        dataList = "PENDING";
    }
    else {
        dataList.Data = attachList;
    }
    const tableCols = [

        { colTitle: "تاریخ پیوست", colName: "PAttachDate", showInMobile: true },
        { colTitle: "نام فایل", colName: "AttachFileName", showInMobile: true }

    ]
    const tableRowButtons = [
        {
            title: "حذف پیوست", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف مشتری',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteAttachment(item.ID, "Staff", () => { dispatch(getStaffAttachments(staffID)) })
                }))
            }
        },
        { title: "دانلود", type: "common", icon:<Download size={18} color="blue" className="rowBtn"/>, className: "group-Btn-small rowBtn", onclick: (item) => downloadFile(item.ID, "Staff") }
    ]
    function attach() {
        dispatch(attachFile(document.getElementById("staffAttach"), staffID, "Staff", () => { dispatch(getStaffAttachments(staffID)) }));
    }

    return (
        <Fragment>
            <Row>
                <Col md={5} className="form-group">
                    <input type="file" className="form-control" id="staffAttach" style={{ width: "85%", display: "inline-block" }} />
                    <Button className="group-Btn-smalll" onClick={attach}><Upload size={18} /></Button>
                </Col>
            </Row>
            <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} dataList={dataList} />
        </Fragment>

    )
}
export default StaffAttachments;